module.exports = __webpack_public_path__ + "img/lineapps-transparente.d0f67ab2.png";